import { ProcessStatus } from 'appTypes';

export enum WorkflowType {
  Plan = 'T',
  TravelTime = 'TT',
  Speed = 'RT',
  Timeline = 'TL',
  Queuing = 'Q',
  Detouring = 'PD',
  RouteMonitoring = 'RM',
  OriginDestination = 'OD',
}

export namespace WorkflowType {
  export function isTimelineIsh(workflowType: WorkflowType) {
    return [WorkflowType.Timeline, WorkflowType.Detouring].includes(
      workflowType,
    );
  }
}

export const restApiUrl = '/server';

/**
 * Defines the Navbar order.
 */
export const WORKFLOWS_ALL_ENABLED = [
  WorkflowType.Timeline,
  WorkflowType.Plan,
  WorkflowType.Speed,
  WorkflowType.TravelTime,
  WorkflowType.Detouring,
  WorkflowType.Queuing,
  WorkflowType.RouteMonitoring,
  WorkflowType.OriginDestination,
];

export const MAXIMIZE_MAP = 'map';
export const MAXIMIZE_DATA = 'data';

export const BIN_15_MINS = '15';
export const BE_BIN_15_MINS = 15;
export const BIN_60_MINS = '60';
export const BE_BIN_60_MINS = 60;

export const VIZ_MODE_CHART = 'chart';
export const VIZ_MODE_TABLE = 'table';

export const COMPARISON_MODE_MONTH = 'month';
export const COMPARISON_MODE_DAY = 'day';

export enum MapStyle {
  Dark = 'dark',
  Sat = 'sat',
  Light = 'light',
}

export enum ScenarioSetupUIMode {
  Create = 'create',
  Edit = 'edit',
  Scenarios = 'previous',
}

export enum ODUIMode {
  View = 'view',
  Create = 'create',
}

export const mapboxApiKey =
  'pk.eyJ1IjoicGZyaWVkbWFuIiwiYSI6ImNscHVjb2xjcjBqNmwyanBscWMwNWZiZnUifQ.QRTJ67oscepSyJARJ-Pgug';

export enum DayTypes {
  Weekday = 'Weekday',
  MeWeekday = 'MeWeekday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday',
}

export const ExtendedDayTypes = {
  ...DayTypes,
  AllDays: 'all',
} as const;

export type ExtendedDayTypes =
  (typeof ExtendedDayTypes)[keyof typeof ExtendedDayTypes];

interface RouteMonitoringHeader {
  title: string;
  size: number;
  val: string;
  caption?: string;
  typical?: string;
}

export const ROUTE_MONITORING_NAME_WIDTH_DEFAULT = 192;

export const ROUTE_MONITORING_HEADERS_REALTIME: RouteMonitoringHeader[] = [
  {
    title: 'Route Name',
    size: ROUTE_MONITORING_NAME_WIDTH_DEFAULT,
    val: 'routeName',
  },
  {
    title: 'Travel Time',
    size: 97,
    val: 'traveltime',
    caption: 'Current',
    typical: 'typicalTraveltime',
  },
  { title: 'Condition', size: 95, val: 'conditionScore' },
];

export const ROUTE_MONITORING_HEADERS: RouteMonitoringHeader[] = [
  {
    title: 'Route Name',
    size: ROUTE_MONITORING_NAME_WIDTH_DEFAULT,
    val: 'routeName',
  },
  {
    title: 'Average',
    size: 95,
    val: 'avgTraveltime',
    caption: 'Travel Time',
    typical: 'avgTypicalTravelTime',
  },
  {
    title: 'Highest',
    size: 95,
    val: 'maxTraveltime',
    caption: 'Travel Time',
    typical: 'maxTraveltimeTyp',
  },
  {
    title: 'Slowdown Period',
    size: 136,
    val: 'congestedTime',
    caption: 'Total',
  },
  { title: 'Condition', size: 95, val: 'conditionScore' },
];
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

export const MAX_CHARS = 255;

export const SpecialEventStatusVariant = {
  requested: 'requested',
  loading: 'loading',
  available: 'available',
} as const;

export const PROCESS_STATUS = {
  NEW: 'new',
  PROCESSING: 'processing',
  DONE: 'done',
  ERROR: 'error',
} as const;

export const ACTIVE_STATUSES: ProcessStatus[] = [
  PROCESS_STATUS.NEW,
  PROCESS_STATUS.PROCESSING,
] as const;

export const MAX_OD_SEGMENTS = 70;
export const MIN_OD_SEGMENTS = 2;

export const CHART_RESIZE_DEBOUNCE_MS = 150;
export const TIMELINE_MIN_ZOOM = 8;
